export default class Header {
    constructor() {
        this.appendScrollEventListenerForStickyClass();
        this.toggleMobileNavigation();
        this.toggleStickyClass();
    }

    appendScrollEventListenerForStickyClass() {
        window.addEventListener('scroll', () => {
            this.toggleStickyClass();
        });
    }

    toggleStickyClass() {
        const doc = document.documentElement;
        const offsetTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (offsetTop > 0) {
            document.body.classList.add('sticky-header');
        } else {
            document.body.classList.remove('sticky-header');
        }
    }

    toggleMobileNavigation() {
        const burgerIcon = document.querySelector('.hamburger-icon');

        burgerIcon.addEventListener('click', () => {
            document.body.classList.toggle('-menuopen');
            this.toggleStickyClass();
        });
    }
}
